import {
    StyleSheet
} from "react-native";
import {
    webStyle
} from "ncore-ui-kit";

const stylesheet = StyleSheet.create({
    tripleSlotActions: {
        justifyContent: "space-between",
        flexDirection: "row",
        position: "absolute",
        alignItems: "center",
        zIndex: 5,
        bottom: 0,
        right: 0,
        left: 0
    },
    headerContainer: {
        justifyContent: "space-between",
        flexDirection: "row",
        alignItems: "center",
        flexShrink: 0
    },
    selectionCard: {
        justifyContent: "space-between",
        flexDirection: "row",
        alignItems: "center",
        cursor: "pointer",
        width: "100%",
        ...webStyle({
            transition: "all 0.15s ease"
        })
    },
    selectionContainer: {
        justifyContent: "flex-start",
        flexDirection: "column",
        width: "100%",
        flex: 1
    },
    characterCountContainer: {
        justifyContent: "flex-end",
        flexDirection: "row"
    },
    footerContainer: {
        justifyContent: "flex-end",
        flexDirection: "row",
        flexShrink: 0
    },
    instagramUsernameContainer: {
        justifyContent: "center",
        flexDirection: "column"
    },
    instagramMediaContainer: {
        justifyContent: "center",
        alignItems: "center",
        aspectRatio: 4 / 5,
        maxHeight: 320,
        width: "100%"
    },
    carouselBadgeContainer: {
        justifyContent: "center",
        flexDirection: "row",
        position: "absolute",
        alignItems: "center",
        zIndex: 10
    },
    tripleSlotArrowButton: {
        justifyContent: "center",
        alignItems: "center",
        cursor: "pointer",
        height: 24,
        width: 24
    },
    carouselNavContainer: {
        justifyContent: "center",
        flexDirection: "row",
        position: "absolute",
        alignItems: "center",
        width: "100%",
        zIndex: 10
    },
    carouselArrowButton: {
        justifyContent: "center",
        position: "absolute",
        alignItems: "center",
        cursor: "pointer",
        marginTop: -16,
        height: 32,
        zIndex: 10,
        width: 32,
        top: "50%"
    },
    emptySlotContainer: {
        justifyContent: "center",
        borderStyle: "dashed",
        alignItems: "center",
        position: "relative",
        cursor: "pointer",
        aspectRatio: 1,
        flex: 1
    },
    selectionCardIcon: {
        justifyContent: "center",
        alignItems: "center",
        height: 48,
        width: 48
    },
    selectionCardBody: {
        justifyContent: "center",
        flexDirection: "column",
        flex: 1
    },
    imagePickerBadge: {
        justifyContent: "center",
        position: "absolute",
        alignItems: "center",
        zIndex: 5
    },
    slotRemoveButton: {
        justifyContent: "center",
        position: "absolute",
        alignItems: "center",
        cursor: "pointer",
        zIndex: 10,
        height: 20,
        width: 20,
        right: 4,
        top: 4
    },
    imagePickerItem: {
        justifyContent: "center",
        alignItems: "center",
        overflow: "hidden",
        cursor: "pointer",
        aspectRatio: 1,
        height: 56,
        width: 56
    },
    modeBadgeButton: {
        justifyContent: "center",
        flexDirection: "row",
        alignItems: "center",
        cursor: "pointer"
    },
    tagChip: {
        justifyContent: "center",
        alignItems: "center",
        cursor: "pointer"
    },
    languageSelectorContainer: {
        flexDirection: "row",
        alignItems: "center",
        flexWrap: "wrap"
    },
    instagramCaptionContainer: {
        maxHeight: 120,
        width: "100%"
    },
    bookmarkContainer: {
        alignItems: "flex-end",
        flex: 1
    },
    bodyContainer: {
        flexDirection: "row",
        flex: 1,
        ...webStyle({
            overflowY: "auto",
            minHeight: 0
        })
    },
    formatWarningContainer: {
        width: "100%"
    },
    tripleSlotsContainer: {
        flexDirection: "row",
        alignItems: "center",
        width: "100%"
    },
    gridPreviewContainer: {
        flexDirection: "row",
        alignItems: "center",
        overflow: "hidden",
        width: "100%"
    },
    imagePickerContainer: {
        flexDirection: "row",
        alignItems: "center",
        flexWrap: "wrap"
    },
    previewTabContainer: {
        flexDirection: "row",
        alignItems: "center",
        flexWrap: "wrap",
        width: "100%"
    },
    instagramActionsBar: {
        flexDirection: "row",
        alignItems: "center"
    },
    mediaSourceActions: {
        flexDirection: "row",
        alignItems: "center",
        flexWrap: "wrap"
    },
    shareModeContainer: {
        flexDirection: "row",
        alignItems: "center",
        flexWrap: "wrap"
    },
    tagChipsContainer: {
        flexDirection: "row",
        alignItems: "center",
        flexWrap: "wrap"
    },
    selectionCardLeft: {
        flexDirection: "row",
        alignItems: "center",
        flex: 1
    },
    gridPreviewBadge: {
        position: "absolute",
        alignItems: "center",
        zIndex: 5
    },
    gridPreviewItem: {
        position: "relative",
        overflow: "hidden",
        cursor: "pointer",
        aspectRatio: 1,
        flex: 1
    },
    tripleSlotBadge: {
        position: "absolute",
        alignItems: "center",
        zIndex: 5
    },
    instagramHeader: {
        flexDirection: "row",
        alignItems: "center"
    },
    tripleSlotCard: {
        position: "relative",
        overflow: "hidden",
        cursor: "pointer",
        aspectRatio: 1,
        flex: 1
    },
    titleContainer: {
        flexDirection: "row",
        alignItems: "center"
    },
    container: {
        maxWidth: "100%",
        width: 760,
        ...webStyle({
            maxHeight: "90%",
            display: "flex"
        })
    },
    limitWarningContainer: {
        width: "100%"
    },
    carouselHintContainer: {
        width: "100%"
    },
    imagePickerThumbnail: {
        height: "100%",
        width: "100%"
    },
    modeChangeButton: {
        marginLeft: "auto"
    },
    tripleHintContainer: {
        width: "100%"
    },
    singleHintContainer: {
        width: "100%"
    },
    dragActiveSlotCard: {
        opacity: 0.5
    },
    closeButton: {
        cursor: "pointer"
    },
    warningContainer: {
        width: "100%"
    },
    tripleSlotImage: {
        height: "100%",
        width: "100%"
    },
    postMedia: {
        height: "100%",
        width: "100%"
    },
    instagramAvatar: {
        height: 32,
        width: 32
    },
    previewSection: {
        maxWidth: 320,
        width: "100%"
    },
    carouselNavDot: {
        height: 6,
        width: 6
    },
    instagramCard: {
        width: "100%"
    },
    editorSection: {
        flex: 1
    }
});
export default stylesheet;
